
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  props: {
    textOne: String,
    textTwo: String,
    path: String
  },
  setup(props) {
    return {
      textOneToBeRendered: props.textOne,
      textTwoToBeRendered: props.textTwo,
      pathToGo: props.path
    };
  },
});
